var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvisorySurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41669 10.8333L6.0704 12.1407C6.29164 12.5832 6.40226 12.8044 6.55005 12.9962C6.68118 13.1663 6.83369 13.3188 7.00381 13.4499C7.19553 13.5977 7.41677 13.7083 7.85926 13.9296L9.16669 14.5833L7.85926 15.237C7.41677 15.4582 7.19553 15.5689 7.00382 15.7167C6.83369 15.8478 6.68118 16.0003 6.55005 16.1704C6.40226 16.3621 6.29164 16.5834 6.0704 17.0259L5.41669 18.3333L4.76297 17.0259C4.54173 16.5834 4.43111 16.3621 4.28333 16.1704C4.15219 16.0003 3.99968 15.8478 3.82956 15.7167C3.63784 15.5689 3.4166 15.4582 2.97412 15.237L1.66669 14.5833L2.97412 13.9296C3.4166 13.7083 3.63784 13.5977 3.82956 13.4499C3.99968 13.3188 4.15219 13.1663 4.28333 12.9962C4.43111 12.8044 4.54173 12.5832 4.76297 12.1407L5.41669 10.8333Z",
    stroke: "#7E5AE2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.66663L13.4822 4.22031C13.7172 4.83133 13.8347 5.13685 14.0174 5.39383C14.1794 5.62159 14.3784 5.82058 14.6062 5.98253C14.8631 6.16526 15.1686 6.28276 15.7797 6.51777L18.3334 7.49996L15.7797 8.48214C15.1686 8.71715 14.8631 8.83466 14.6062 9.01739C14.3784 9.17934 14.1794 9.37833 14.0175 9.60609C13.8347 9.86307 13.7172 10.1686 13.4822 10.7796L12.5 13.3333L11.5178 10.7796C11.2828 10.1686 11.1653 9.86307 10.9826 9.60609C10.8206 9.37833 10.6216 9.17934 10.3939 9.01739C10.1369 8.83466 9.83139 8.71715 9.22037 8.48214L6.66669 7.49996L9.22037 6.51777C9.83139 6.28276 10.1369 6.16526 10.3939 5.98253C10.6216 5.82058 10.8206 5.62159 10.9826 5.39383C11.1653 5.13685 11.2828 4.83133 11.5178 4.22031L12.5 1.66663Z",
    stroke: "#7E5AE2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvisorySurvey);
export default __webpack_public_path__ + "static/media/advisory_survey.4fc0da65492087a5d57347b539a944f7.svg";
export { ForwardRef as ReactComponent };